import React, { useEffect, useState } from "react";
import axios from "axios";
import cup from "../../../../../../../../assets/images/cup 2.png";
import AllDataHeader from "../../../../../../../Reuseable/AllDataHeader";
import AuditionCardReuse from "../../../../../../../AuditionAdmin/AuditionCardReuse";
import LoaderPost from "../../../../../../../Reuseable/LoaderPost";

const RoundInstructionList = () => {
  const [events, setEvents] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get("/api/audition-admin/assigned-audition").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.event);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Filter live auditions videos"
        image={cup}
        count={"Zero"}
      />{" "}
      {buffer ? (
        <LoaderPost />
      ) : (
        <AuditionCardReuse
          data={events}
          roundInstruction={`/audition-admin/audition/round-instruction-details`}
        />
      )}
    </>
  );
};

export default RoundInstructionList;
